/**
 * Storage Constants - Avatar-Scoped Local Storage Management
 *
 */

// Storage Keys
export const STORAGE_KEYS = {
  // Authentication & Tokens (global - never cleared)
  basicAuth: 'basicAuth',
  SCMCognitoToken: 'secom_cognito_token',

  // Policy A: SESSION_PERSISTENT - cleared on logout only
  SELECTED_HOME_GROUP: 'selectedCurrentHomeGroup_',

  // Policy B: MULTI_AVATAR_PERSISTENT - Persists across logouts (up to 5 avatars)
  CAMERA_LIST_SETTING: 'cameraListSetting_', // only accessible to avatar owners/admins

  // Policy D/E: AVATAR_SCOPED - Cleared on avatar switch OR logout
  MULTICAM_LAYOUT: 'multicamLayout',

  // Clip parameters (global, align with D/E behavior)
  CLIP_LIST_POSITION: 'clipListPosition',
  CLIP_SEARCH_PARAMS: 'clipSearchParams',
  LastVideoClipsSearchParams: 'last_video_clips_seach_params',

  // System keys
  RECENT_AVATARS: 'system_recent_avatars',
  MIGRATION_VERSION: 'system_migration_version',
};

// Retention Policies
export const RETENTION_POLICIES = {
  SESSION_PERSISTENT: 'A', // cleared on logout only
  MULTI_AVATAR_PERSISTENT: 'B', // persists across logouts (up to 5 avatars)
  AVATAR_SCOPED_D: 'D', // cleared on avatar switch OR logout
  AVATAR_SCOPED_E: 'E', // cleared on avatar switch OR logout
  GLOBAL: 'GLOBAL', // system-wide, never cleared
};

export const CURRENT_MIGRATION_VERSION = '1.0';
export const MAX_AVATARS = 5;

// Legacy keys to remove during migration
export const LEGACY_KEYS_TO_REMOVE = [
  'accessToken',
  'idToken',
  'refreshToken',
  'client_time',
  'server_time',
  'cameraDetailListSetting_',
  'cameraLayout_',
  'videoLowLatencyModeById_',
  'secom_current_avatar',
  'cameraListSetting_',
];

// Avatar-scoped keys that require avatar ID for scoping
export const AVATAR_SCOPED_KEYS = [
  STORAGE_KEYS.SELECTED_HOME_GROUP,
  STORAGE_KEYS.CAMERA_LIST_SETTING,
];

// Keys that should be automatically JSON parsed/stringified
export const JSON_KEYS = [
  STORAGE_KEYS.CLIP_SEARCH_PARAMS,
  STORAGE_KEYS.CLIP_LIST_POSITION,
  STORAGE_KEYS.LastVideoClipsSearchParams,
  STORAGE_KEYS.CAMERA_LIST_SETTING,
  STORAGE_KEYS.RECENT_AVATARS,
  STORAGE_KEYS.SCMCognitoToken,
];

// Keys to preserve during logout cleanup
export const LOGOUT_EXCLUSION_KEYS = [
  STORAGE_KEYS.CAMERA_LIST_SETTING,
  STORAGE_KEYS.RECENT_AVATARS,
  STORAGE_KEYS.MIGRATION_VERSION,
];

// Default values for initial state
export const DEFAULT_VALUES = {
  MULTICAM_LAYOUT: 1, // 1 column for large screens
  CLIP_SEARCH_PARAMS: {}, // empty object
  CLIP_LIST_POSITION: 0, // Start at position 0
  RECENT_AVATARS: [], // empty array
  SELECTED_HOME_GROUP: null, // no group selected initially
  CAMERA_LIST_SETTING: [], // empty array
};
